import { render } from "./LazyLoadSelect.vue?vue&type=template&id=0bee3aac"
import script from "./LazyLoadSelect.vue?vue&type=script&lang=js"
export * from "./LazyLoadSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__